import { __require as a } from "./main45.js";
var r, e;
function u() {
  if (e) return r;
  e = 1;
  var o = a(), t = typeof self == "object" && self && self.Object === Object && self, f = o || t || Function("return this")();
  return r = f, r;
}
export {
  u as __require
};
